import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonDropdown from './CommonDropdown';
import MultiSelectDropdown from './MultiSelectDropdown';
import { GroupSortBarProps } from '../types/common.types';

// Shared Group By / Sort By control, dropped above any CommonTable. The field list
// (value/label pairs) is supplied by the caller from that table's own columns, so the
// same component works across differently-shaped tables (departments, approvals, tickets).
// Group By accepts more than one field — picking several nests the table into
// sub-groups in the order they were selected (first pick is the outermost group).
const GroupSortBar: React.FC<GroupSortBarProps> = ({
  fields,
  groupBy,
  onGroupByChange,
  sortBy,
  onSortByChange,
  sortDirection,
  onSortDirectionChange,
}) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={1}
      alignItems={{ md: 'center' }}
      sx={{ flexWrap: 'wrap', rowGap: 1 }}
    >
      <Box sx={{ width: { xs: '100%', md: 240 } }}>
        <MultiSelectDropdown
          label="Group by"
          value={groupBy}
          onChange={onGroupByChange}
          options={fields}
          placeholder="No grouping"
        />
      </Box>
      <Box sx={{ width: { xs: '100%', md: 200 } }}>
        <CommonDropdown
          label="Sort by"
          value={sortBy}
          onChange={(event) => onSortByChange(event.target.value)}
          options={[{ label: 'Default', value: '' }, ...fields]}
        />
      </Box>
      {sortBy ? (
        <Box sx={{ width: { xs: '100%', md: 170 } }}>
          <CommonDropdown
            label="Order"
            value={sortDirection}
            onChange={(event) => onSortDirectionChange(event.target.value as 'asc' | 'desc')}
            options={[
              { label: 'Ascending', value: 'asc' },
              { label: 'Descending', value: 'desc' },
            ]}
          />
        </Box>
      ) : null}
    </Stack>
  );
};

export default GroupSortBar;
